export const GET_PROERTY_TYPES = '[Property Type Action] Get property types';
export const CONFIRMED_GET_PROERTY_TYPES = '[Property Type Action] Confirmed Get property types';
